import React from 'react';
const IMAGES = [{
  src: 'https://cdn.magicpatterns.com/uploads/d2TLA4etwLg2JcwG5iqFpB/6ae0fc2f-6160-41c6-9db1-342c76651d46.jpg',
  alt: 'Two-story Arizona home with uplit palm trees and glowing step lights',
  span: 'lg:col-span-2 lg:row-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ctfsHmmy6cKNXStvG4ezVw/Screenshot_2026-07-21_103139.png',
  alt: 'Spanish-style home entry with warm accent lighting on columns and arches',
  span: ''
}, {
  src: 'https://cdn.magicpatterns.com/patterns/generated-images/21a30847-c299-477a-920a-bfb490341c1c.jpg',
  alt: 'Desert backyard at night with uplit palms and path lighting',
  span: ''
}, {
  src: 'https://cdn.magicpatterns.com/uploads/1ATotSgthc6ZFSAEV9iP7K/Screenshot_2026-07-21_103154.png',
  alt: 'Desert estate at dusk lined with warm path and facade lighting',
  span: 'lg:col-span-2'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/mq2a85g6VmYpwNmJo9TfgR/876d9aea-dfe3-40df-b26b-4f8dc749452f.jpg',
  alt: 'Modern low-voltage path light fixtures installed along a paver walkway',
  span: ''
}];
export function Gallery() {
  return <section id="gallery" className="w-full bg-background py-20 lg:py-28" data-id="element-84" data-mp="w9b4pu48glvn">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-85" data-mp="1135y5p9n4f7x">
        <div className="max-w-2xl" data-id="element-86" data-mp="1547p7itelkyt">
          <span className="font-display text-lg tracking-wide text-accent" data-id="element-87" data-mp="1536b15h3cicv">Our Work</span>
          <h2 className="mt-2 font-display text-4xl leading-tight text-foreground sm:text-5xl" data-id="element-88" data-mp="8f9t9x9x3h02">
            Recent Projects
          </h2>
          <p className="mt-4 text-lg text-muted-foreground" data-id="element-89" data-mp="hedd53gws0fm">
            A look at homes we’ve transformed across the East Valley — real installs, real results.
          </p>
        </div>

        <div className="mt-12 grid auto-rows-[220px] grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-90" data-mp="mb3s1ngz8pzg">
          {IMAGES.map(img => <div key={img.src} className={`group relative overflow-hidden rounded-xl border border-border ${img.span}`} data-id="element-91" data-mp="1xru0ld8vhtw8">
              <img src={img.src} alt={img.alt} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-92" data-mp="3txm9yggevdfa" />
            </div>)}
        </div>
      </div>
    </section>;
}